export const SET_USERS = Symbol('usersByIds/SET_USERS');
export const SET_QUEUE = Symbol('usersByIds/SET_QUEUE');
